import { Box, ColorOptions, Icon, Loader, ModBox } from '@jfs/ui-new'
import { FC, useEffect, useState } from 'react'
import { TextInput } from 'react-native'
import { styles } from './styles'

export interface SearchBarProps {
  onChange: (text: string) => void
  placeholder?: string
  value?: string
  hide?: boolean
  hideLeftIcons?: boolean
  fontSize?: number
  transparentBg?: boolean
  placeholderTextColor?: String
  rightCompColor?: ColorOptions
  onClearPress?: () => void
  showRightIcon?: boolean
  fullWidth?: boolean
  onSearchPress?: () => void
  isLoading?: boolean
}

const SearchBar: FC<SearchBarProps> = (props) => {
  const {
    placeholder = 'Search',
    value,
    hide = true,
    onClearPress,
    showRightIcon = false,
    fullWidth = false,
    onSearchPress,
    isLoading,
  } = props

  const [searchPressed, setSearchPressed] = useState(false)
  const isEditingStarted = value?.length > 0

  useEffect(() => {
    if (!isEditingStarted) {
      setSearchPressed(false)
    }
  }, [isEditingStarted])
  if (hide) {
    return null
  }
  const handleChange = (text: string) => {
    props.onChange(text)
    setSearchPressed(false)
  }

  const hideLeftIcons = props?.hideLeftIcons ?? false
  const transparentBg = props?.transparentBg ?? false
  const fontSize = props?.fontSize
  const placeholderTextColor = props?.placeholderTextColor
  const rightCompColor = props?.rightCompColor

  const onSearchPressed = () => {
    setSearchPressed(true)
    onSearchPress && onSearchPress()
  }
  const onClearPressed = () => {
    setSearchPressed(false)
    onClearPress && onClearPress()
  }
  return (
    <Box {...styles.container(transparentBg, fullWidth)}>
      {!hideLeftIcons && <Icon id={'SEARCH'} size={16} color={'LIGHT_GREY'} />}
      <TextInput
        placeholder={placeholder}
        placeholderTextColor={placeholderTextColor}
        style={styles.input(hideLeftIcons, fontSize, transparentBg)}
        onChangeText={handleChange}
        autoCorrect={false}
        allowFontScaling
        autoCompleteType="name"
        autoCapitalize="none"
        value={value}
      />

      <ModBox
        show={showRightIcon}
        {...styles.rightIconContainer}
        onPress={searchPressed ? onClearPressed : onSearchPressed}
        disabled={isEditingStarted ? false : true}>
        <ModBox show={isLoading}>
          <Loader color={'PRIMARY'} type={16} />
        </ModBox>
        <ModBox show={!isLoading}>
          <Icon id={searchPressed ? 'CLOSE' : 'SEARCH'} size={16} color={rightCompColor ?? 'LIGHT_GREY'} />
        </ModBox>
      </ModBox>
    </Box>
  )
}

export default SearchBar
